import { render, staticRenderFns } from "./booking_summary.vue?vue&type=template&id=b6eb2b36&"
import script from "./booking_summary.vue?vue&type=script&lang=js&"
export * from "./booking_summary.vue?vue&type=script&lang=js&"
import style0 from "./booking_summary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports